import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SharjahPoliceEmblem } from '../SharjahPoliceEmblem';
import { FingerprintIcon, ShieldOffIcon, SearchIcon, UserCheckIcon, ActivityIcon, CheckCircleIcon } from 'lucide-react';
const PAIR2_LOGO = 'https://cdn.magicpatterns.com/uploads/51QRCG1WJpxN6EwND9yhQF/Pair2_(2).svg';
const SECURITY_POINTS = [{
  label: 'تحديد هوية السائق بشكل فوري',
  icon: FingerprintIcon
}, {
  label: 'منع التشغيل غير المصرح به',
  icon: ShieldOffIcon
}, {
  label: 'تسريع إجراءات الوصول الى المعلومه',
  icon: SearchIcon
}];
const TRAFFIC_POINTS = [{
  label: 'ربط المخالفات بالسائق الفعلي',
  icon: UserCheckIcon
}, {
  label: 'تحليل استباقي لسلوك السائقين',
  icon: ActivityIcon
}, {
  label: 'تحسين انضباط و التزام السائقين',
  icon: CheckCircleIcon
}];
export function ImpactSlide() {
  const reduce = useReducedMotion();
  const base = reduce ? {
    duration: 0
  } : undefined;
  return <section dir="rtl" className="relative w-screen h-screen overflow-hidden flex flex-col" style={{
    background: '#EDF1F4'
  }} data-id="element-450">
      {/* ===== BACKGROUND ===== */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden data-id="element-451">
        <div className="absolute -top-40 -right-40 w-[60vmax] h-[60vmax] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, rgba(47,169,156,0.06) 0%, transparent 70%)'
      }} data-id="element-452" />
        <div className="absolute -bottom-40 -left-40 w-[50vmax] h-[50vmax] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, rgba(47,169,156,0.04) 0%, transparent 70%)'
      }} data-id="element-453" />
        <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0V0zm1 1h38v38H1V1z' fill='%230B1328' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
      }} data-id="element-454" />
      </div>

      {/* ===== TOP BAR ===== */}
      <motion.div initial={{
      opacity: 0,
      y: -14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={base ?? {
      duration: 0.9,
      delay: 0.15,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative z-20 flex items-center justify-between pt-[clamp(1.5rem,3.5vh,3rem)] px-[clamp(1.75rem,4.5vw,4.5rem)] shrink-0" data-id="element-455">
        <SharjahPoliceEmblem variant="light" data-id="element-456" />
        <img src={PAIR2_LOGO} alt="Pair²" className="h-[clamp(2.5rem,5vh,3.5rem)] w-auto" style={{
        filter: 'drop-shadow(0 4px 18px rgba(47,169,156,0.28))'
      }} draggable={false} data-id="element-457" />
      </motion.div>

      {/* ===== MAIN CONTENT ===== */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-center px-[clamp(3rem,6vw,8rem)] pb-[clamp(2rem,4vh,3rem)]" data-id="element-458">
        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={base ?? {
        duration: 0.8,
        delay: 0.2
      }} className="font-arabic-display font-black text-center mb-3 leading-[1.15]" style={{
        color: '#0B1328',
        fontSize: 'clamp(2rem, 3.5vw, 3rem)'
      }} data-id="element-459">
          الأثر الأمني والمروري
        </motion.h2>

        {/* Teal underline */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 0.45,
        scaleX: 1
      }} transition={base ?? {
        duration: 0.6,
        delay: 0.35
      }} className="mx-auto h-[2.5px] rounded-full mb-[clamp(2.5rem,5vh,4rem)]" style={{
        width: 'clamp(3rem, 5vw, 4rem)',
        background: '#2FA99C'
      }} data-id="element-460" />

        {/* Two-column layout */}
        <div className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-[clamp(2rem,4vw,4rem)]" data-id="element-461">
          {/* RIGHT: أمنياً (first in RTL) */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={base ?? {
          duration: 0.8,
          delay: 0.4
        }} className="rounded-[1.5rem] p-[clamp(1.5rem,3vw,2.5rem)] flex flex-col" style={{
          background: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(47,169,156,0.15)',
          backdropFilter: 'blur(14px)',
          boxShadow: '0 12px 40px -18px rgba(14,93,85,0.12)'
        }} data-id="element-462">
            <div className="flex items-center gap-3 mb-[clamp(1.5rem,3vh,2.5rem)]" data-id="element-463">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{
              background: 'rgba(47,169,156,0.1)'
            }} data-id="element-464">
                <ShieldOffIcon className="w-5 h-5 text-[#2FA99C]" data-id="element-465" />
              </div>
              <h3 className="font-arabic-display font-bold" style={{
              color: '#2FA99C',
              fontSize: 'clamp(1.3rem, 2vw, 1.75rem)'
            }} data-id="element-466">
                أمنياً
              </h3>
            </div>

            <div className="flex flex-col gap-5" data-id="element-467">
              {SECURITY_POINTS.map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={base ?? {
              duration: 0.6,
              delay: 0.55 + i * 0.1
            }} className="flex items-center gap-4" data-id="element-468">
                  <div className="w-9 h-9 rounded-lg bg-[#2FA99C]/8 flex items-center justify-center shrink-0 border border-[#2FA99C]/15" data-id="element-469">
                    <point.icon className="w-[18px] h-[18px] text-[#2FA99C]" data-id="element-470" />
                  </div>
                  <span className="font-arabic-body font-semibold text-right" style={{
                color: '#0B1328',
                fontSize: 'clamp(1rem, 1.3vw, 1.2rem)'
              }} data-id="element-471">
                    {point.label}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* LEFT: مرورياً (second in RTL) */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={base ?? {
          duration: 0.8,
          delay: 0.5
        }} className="rounded-[1.5rem] p-[clamp(1.5rem,3vw,2.5rem)] flex flex-col" style={{
          background: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(47,169,156,0.15)',
          backdropFilter: 'blur(14px)',
          boxShadow: '0 12px 40px -18px rgba(14,93,85,0.12)'
        }} data-id="element-472">
            <div className="flex items-center gap-3 mb-[clamp(1.5rem,3vh,2.5rem)]" data-id="element-473">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{
              background: 'rgba(47,169,156,0.1)'
            }} data-id="element-474">
                <ActivityIcon className="w-5 h-5 text-[#2FA99C]" data-id="element-475" />
              </div>
              <h3 className="font-arabic-display font-bold" style={{
              color: '#2FA99C',
              fontSize: 'clamp(1.3rem, 2vw, 1.75rem)'
            }} data-id="element-476">
                مرورياً
              </h3>
            </div>

            <div className="flex flex-col gap-5" data-id="element-477">
              {TRAFFIC_POINTS.map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={base ?? {
              duration: 0.6,
              delay: 0.65 + i * 0.1
            }} className="flex items-center gap-4" data-id="element-478">
                  <div className="w-9 h-9 rounded-lg bg-[#2FA99C]/8 flex items-center justify-center shrink-0 border border-[#2FA99C]/15" data-id="element-479">
                    <point.icon className="w-[18px] h-[18px] text-[#2FA99C]" data-id="element-480" />
                  </div>
                  <span className="font-arabic-body font-semibold text-right" style={{
                color: '#0B1328',
                fontSize: 'clamp(1rem, 1.3vw, 1.2rem)'
              }} data-id="element-481">
                    {point.label}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>

        {/* Bottom Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={base ?? {
        duration: 0.8,
        delay: 1
      }} className="mt-[clamp(2rem,4vh,3.5rem)] px-[clamp(1.5rem,3vw,3rem)] py-[clamp(0.75rem,1.5vh,1.25rem)] rounded-full text-center" style={{
        background: 'rgba(47,169,156,0.08)',
        border: '1px solid rgba(47,169,156,0.2)'
      }} data-id="element-482">
          <span className="font-arabic-body font-semibold" style={{
          color: '#0B1328',
          fontSize: 'clamp(0.9rem, 1.2vw, 1.1rem)'
        }} data-id="element-483">
            منظومة تعزز الأمن وتدعم الانضباط المروري من خلال بيانات دقيقة في
            الوقت الفعلي
          </span>
        </motion.div>
      </div>
    </section>;
}